(function() {
    'use strict';

a3_pilot_reports.directive('crewRouteInfoPanel',crewRouteInfoPanel);
     
   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name crewRouteInfoPanel
   * @restrict EA
   * @description
   *   Implementation of crewRouteInfoPanel
   *
   *   Initialize the crew Route Info panel 
   * @example
   *   Usage:
   *   <div crew-route-info-panel></div>
   * @ngInject
   */    
    function crewRouteInfoPanel($routeParams, $uibModal) {
    
    function link ($scope, element, attrs) {     

        $scope.showDefaultView = showDefaultView;
        $scope.showFlightTimes = showFlightTimes;      
        $scope.showCommercialView = showCommercialView;
        $scope.showDelaysView = showDelaysView;
        $scope.toggleshowHiddenRows = toggleshowHiddenRows;
        $scope.delaysColumns = false;
        $scope.showDate = showDate;
        $scope.openCrewContactsModal = openCrewContactsModal;

        $scope.showHiddenRows = false;
        $scope.defaultColumns = true;
        $scope.commercialColumns = false;
        $scope.timesColumns = false;
        $scope.crewMeals = '';
     

        function showDefaultView() {
            $scope.defaultColumns = true;
            $scope.timesColumns = false;
            $scope.commercialColumns = false;
            $scope.delaysColumns = false;
        }

        function showFlightTimes() {          
            $scope.defaultColumns = false;
            $scope.timesColumns = true;
            $scope.commercialColumns = false;
            $scope.delaysColumns = false;
        }

        function showCommercialView() {
            $scope.defaultColumns = false;
            $scope.timesColumns = false;
            $scope.commercialColumns = true;
            $scope.delaysColumns = false;
        }
        
        function showDelaysView(){
            $scope.defaultColumns = false;
            $scope.timesColumns = false;
            $scope.commercialColumns = false;
            $scope.delaysColumns = true;
        }

        function toggleshowHiddenRows(){
            if($scope.crewRouteInfoPanel.hasAircraftPositions){
                $scope.showHiddenRows =! $scope.showHiddenRows;
            }
        }

        function showDate(acRouteSTD, flightSTD){
            var datediff = moment(acRouteSTD).startOf('day').diff(moment(flightSTD).startOf('day'), 'days');
            return datediff != 0;
        }

        /**
         * Open dialog with the crew details
         * @memberof BucketCtrl
         */
        function openCrewContactsModal(crewInfo, selectedflightid, selectedFlightNo) {  
            if(crewInfo && crewInfo.length > 0){
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/CrewRoute/dlgCrewContacts.html',
                controller: 'CrewContactsModalCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'md',
                resolve: {
                    crewInfo: function () { return crewInfo; },
                    selectedflightid: function () { return selectedflightid; },
                    selectedFlightNo: function () { return selectedFlightNo; }
                    }
                });
            }                       
        }

    }
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/crewRouteInfoPanel.tpl.html',
			scope : false,
            link: link 
    }
}

})();